// hooks/useRedirectHome.ts
import { useNavigate } from 'react-router-dom';
import { redirectHome } from '../utils/navigation';

export const useRedirectHome = () => {
  const navigate = useNavigate();
  return () => redirectHome(navigate);
};